<template>
  <div>
    <header-div v-if="isshow"></header-div>
    <orgheader-div v-else></orgheader-div>

    <div class="help-list">
      <h1>候选人篇</h1>
      <div class="help-item" v-for="(item,index) in candidate" :key="index">
        <h3>{{index+1}}.{{item.name}}</h3>
        <video :src="item.url" controls="" controlslist="nodownload"></video>
      </div>
    </div>

    <div class="help-list">
      <h1>机构篇</h1>
      <div class="help-item" v-for="(item,index) in org" :key="index">
        <h3>{{index+1}}.{{item.name}}</h3>
        <video :src="item.url" controls="" controlslist="nodownload"></video>
      </div>
    </div>
    <footer-div v-if="isshow"></footer-div>
    <orgfooter-div v-else></orgfooter-div>
  </div>
</template>

<script>
  import headerDiv from '../pageMember/components/header'
  import footerDiv from '../pageMember/components/footer'
  import orgheaderDiv from '../pageOrg/components/header'
  import orgfooterDiv from '../pageOrg/components/footer'

  export default {
    data() {
      return {
        content: '',
        isshow: false,
        candidate:[],
        org:[]
      }
    },
    created() {
      // 默认选择北京市
      this.$store.state.selectionAddress = window.sessionStorage.getItem('selectionAddress') ? JSON.parse(window.sessionStorage.getItem('selectionAddress')) : {
        categoryname: "北京市",
        city_id: 110100,
        parentid: 1,
        spell: "beijingshi"
      }
      if(JSON.parse(window.localStorage.getItem('user')) === null) {
        this.isshow = true
      }else{
        JSON.parse(window.localStorage.getItem('user')).user_type !== 2 ? this.isshow = true : this.isshow = false
      }
      this.$api.apiContent.videoHelpList().then(res=>{
        this.candidate = res.data.candidate
        this.org = res.data.org
      })
    },
    methods: {
      getCookie(cname) {
        let name = cname + "="
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i].trim()
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ""
      }
    },
    components: {
      headerDiv,
      footerDiv,
      orgheaderDiv,
      orgfooterDiv
    }
  }
</script>

<style scoped lang="scss">
  .help-list{
    width: 1200px;
    margin: 0 auto;
    padding: 30px;
    background: #fff;
    h1{
      font-size: 24px;
      text-align: center;
    }
    .help-item{
      margin-bottom: 30px;
      border-bottom: 1px solid #e2e2e2;
      h3{
        line-height: 150%;
        font-size: 18px;
      }
      video{
        display: block;
        width: 100%;
        height: auto;
        margin: 20px 0;
      }
    }
  }
</style>